import {
    barcodes,
    checkBox,
    textInput,
    ellipse,
    image,
    line,
    measurementPointList,
    measurementPointChart,
    radioButton,
    rectangle,
    svg,
    text,
    dropdown,
    signature,
    varText,
} from '@pdfme/schemas';
import {Font, getDefaultFont, Template} from "@pdfme/common";

export const getFontsData = (): Font => ({
    ...getDefaultFont(),
    "NotoSerifJP-Regular": {
        fallback: false,
        data: 'https://fonts.gstatic.com/s/notoserifjp/v30/xn71YHs72GKoTvER4Gn3b5eMRtWGkp6o7MjQ2bwxOubAILO5wBCU.ttf',
    },
    "NotoSansJP-Regular": {
        fallback: false,
        data: 'https://fonts.gstatic.com/s/notosansjp/v53/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFBEj75vY0rw-oME.ttf',
    },
});

export const getPlugins = () => {
    return {
        Text: text,
        TextInput: textInput,
        VarText: varText,
        RadioGroup: radioButton,
        Checkbox: checkBox,
        MeasurementPointChart: measurementPointChart,
        MeasurementPointList: measurementPointList,
        Dropdown: dropdown,
        Signature: signature,
        QR: barcodes.qrcode,
        Image: image,
        SVG: svg,
        Line: line,
        Rectangle: rectangle,
        Ellipse: ellipse,
    };
};

export const translations: { label: string; value: string }[] = [
    {value: 'en', label: 'English'},
    {value: 'de', label: 'German'},
];

export const getInputFromTemplate = (template: Template): { [key: string]: string | object }[] => {
    if (!Array.isArray(template.schemas)) {
        throw new Error("Invalid template: schemas must be an array");
    }

    const input: { [key: string]: object | string } = {};
    // @ts-ignore
    template.schemas.forEach((page: any[]) => {
        page.forEach((schema: any) => {
            if (!schema.readOnly) {
                input[schema.name] = schema.appRender || schema.content || "";
            }
        });
    });

    return [input];
};
